module.exports = "/_next/static/images/44ed65d98309d3d22d82f9c4711b9857-hero-xs.png.webp";